<template>
  <div
    class="owal-logo__container"
  />
</template>

<script>
export default {
  name: 'OwalLogo',
}
</script>

<style scoped>
.owal-logo__container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 6.625rem;
  width: 6.625rem;
  border-radius: 50%;
  border: 10.9px solid #000;
}

.owal-logo__container::before,
.owal-logo__container::after
 {
  position: relative;
  content: ' ';
  height: 15.24390244%;
  width: 15.24390244%;
  border-radius: 50%;
  background: #DF127D;
  margin: 0 0.5rem;
  align-self: center;
}
</style>
